// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnlV2J_PxiLxbsoNYKHV{width:100%;margin-bottom:40px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/CommonErrorBanner/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,kBAAA","sourcesContent":[".errorBanner {\n  width: 100%;\n  margin-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBanner": `EnlV2J_PxiLxbsoNYKHV`
};
export default ___CSS_LOADER_EXPORT___;
